export const LOGINSUCCESS = 'loginSuccess'  // 登陆成功
export const LOGOUTSUCCESS = 'logoutSuccess'  // 退出成功
export const HIDEMENU = 'hideMenu'  // 隐藏菜单
export const SHOWDIALOG = 'showDialog'  // 打开弹出层
export const CLOSEDIALOG = 'closeDialog'  // 关闭弹出层
export const SHADE = 'shade'  // 打开遮罩层
export const GETMENULIST = 'getMenuList'  // 获取菜单栏
export const ACTIVEMENU = 'activeMenu'  // 激活菜单栏
export const SETMENU = 'setMenu'  // 设置菜单名称
export const GETPATH = 'getPath'  // 获取路径
export const CHANGECOLLAPSE = 'changeCollapse'  //切换logo
export const CHANGEWIDTH = 'changeWidth'  //切换宽度
export const GETOPETATOR = 'getOpetator'  //  获取运营商




// WEBPACK FOOTER //
// ./src/store/types.js